module.exports = __webpack_public_path__ + "media/images/lp_reason-1-48129c79073dca40f526d450a7be1ce0.webp";